import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, DataTable } from "../../../components/ui";
import { Button } from "../../../components/ui";
import { CampaignInvitePanel } from "./CampaignInvitePanel";
import InviteLinkControl from "../../../components/business/InviteLink/InviteLinkControl";
import type { Column } from "../../../components/ui/DataTable";
import type { CampaignView } from "../../../types/types";

interface User extends Record<string, unknown> {
  id: number;
  name: string;
  username: string;
  email: string;
}

interface CampaignViewUsersProps {
  campaign: CampaignView;
  onUpdate: () => void;
}

const CampaignViewUsers: React.FC<CampaignViewUsersProps> = ({
  campaign,
  onUpdate,
}: CampaignViewUsersProps) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const columns: Column<User>[] = [
    { key: "name", header: "Name", render: (user) => user.name },
    { key: "username", header: "Username", render: (user) => user.username },
    { key: "email", header: "Email", render: (user) => user.email },
  ];

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <div>
      <h3 className="text-sm font-semibold text-amber-400 tracking-widest uppercase flex justify-between items-center mb-2">
        Campaign Members
        <Button onClick={() => setModalOpen(true)} variant="primary" size="md">
          Add Users
        </Button>
      </h3>

      <DataTable
        columns={columns}
        data={campaign.users as User[]}
        emptyMessage="No users in this campaign."
        className="mt-4"
      />

      <Modal isOpen={isModalOpen} onClose={handleClose} size="md">
        <ModalHeader title="Invite Users to Chronicle" onClose={handleClose} />
        <ModalBody>
          <CampaignInvitePanel campaignId={campaign.id} onChanged={onUpdate} />
          <div className="border-t border-zinc-800 my-4" />
          <InviteLinkControl campaignId={campaign.id} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CampaignViewUsers;
